import React from 'react';
import { formatStatusLabel } from './processQueueUtils';

function ProcessQueueFilters({
    searchTerm,
    onSearchTermChange,
    searchField,
    onSearchFieldChange,
    searchFields,
    statusFilter,
    onStatusFilterChange,
    statusOptions,
    sortBy,
    onSortByChange,
    sortFields,
    sortOrder,
    onSortOrderChange,
    onSubmit,
    onClear,
    canClear,
    showSort = true,
}) {
    return (
        <form onSubmit={onSubmit} className="process-queue-filters mb-4 p-3 bg-light rounded border">
            <div className="row g-2 g-md-3 align-items-center process-queue-filters__row">
                <div className="col-12 col-md-6 col-lg-auto process-queue-filters__item process-queue-filters__item--search">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Search</span>
                        <input
                            id="queue-search-term"
                            type="text"
                            className="form-control process-queue-filters__control"
                            placeholder="Search…"
                            value={searchTerm}
                            onChange={(e) => onSearchTermChange(e.target.value)}
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => onSearchTermChange('')}
                                aria-label="Clear search input"
                            >
                                <i className="bi bi-x"></i>
                            </button>
                        )}
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Search in</span>
                        <select
                            id="queue-search-field"
                            className="form-select form-select-sm process-queue-filters__control"
                            value={searchField}
                            onChange={(e) => onSearchFieldChange(e.target.value)}
                        >
                            {searchFields.map((f) => (
                                <option key={f.value} value={f.value}>
                                    {f.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Status</span>
                        <select
                            id="queue-status-filter"
                            className="form-select form-select-sm process-queue-filters__control"
                            value={statusFilter}
                            onChange={(e) => onStatusFilterChange(e.target.value)}
                        >
                            <option value="">All statuses</option>
                            {statusOptions.map((s) => (
                                <option key={s} value={s}>
                                    {formatStatusLabel(s)}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {showSort && (
                    <>
                        <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                            <div className="input-group input-group-sm">
                                <span className="input-group-text process-queue-filters__label">Sort by</span>
                                <select
                                    id="queue-sort-by"
                                    className="form-select form-select-sm process-queue-filters__control"
                                    value={sortBy}
                                    onChange={(e) => onSortByChange(e.target.value)}
                                >
                                    {sortFields.map((f) => (
                                        <option key={f.value} value={f.value}>
                                            {f.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                            <div className="input-group input-group-sm">
                                <span className="input-group-text process-queue-filters__label">Order</span>
                                <select
                                    id="queue-sort-order"
                                    className="form-select form-select-sm process-queue-filters__control process-queue-filters__control--narrow"
                                    value={sortOrder}
                                    onChange={(e) => onSortOrderChange(e.target.value)}
                                >
                                    <option value="DESC">Desc</option>
                                    <option value="ASC">Asc</option>
                                </select>
                            </div>
                        </div>
                    </>
                )}

                <div className="col-12 col-lg-auto process-queue-filters__actions d-flex flex-nowrap gap-2">
                    <button type="submit" className="btn btn-primary btn-sm text-nowrap">
                        <i className="bi bi-search me-1"></i>
                        Search
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm text-nowrap"
                        onClick={onClear}
                        disabled={!canClear}
                        title="Clear filters"
                    >
                        <i className="bi bi-x-lg me-1"></i>
                        Clear
                    </button>
                </div>
            </div>
        </form>
    );
}

export default ProcessQueueFilters;
